import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYoutube = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M22.9051 5.81639C22.6434 4.7078 21.8723 3.8347 20.8932 3.53841C19.1187 3 12.0028 3 12.0028 3C12.0028 3 4.88696 3 3.11233 3.53841C2.13329 3.83475 1.36221 4.7078 1.1005 5.81639C0.625 7.82578 0.625 12.0182 0.625 12.0182C0.625 12.0182 0.625 16.2106 1.1005 18.22C1.36221 19.3286 2.13329 20.1653 3.11233 20.4616C4.88696 21 12.0028 21 12.0028 21C12.0028 21 19.1186 21 20.8932 20.4616C21.8723 20.1653 22.6434 19.3286 22.9051 18.22C23.3806 16.2106 23.3806 12.0182 23.3806 12.0182C23.3806 12.0182 23.3806 7.82578 22.9051 5.81639ZM9.6755 15.8246V8.2118L15.623 12.0183L9.6755 15.8246Z" })]
});
const ForwardRef = forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };
